import './clickable-icon-with-legend.scss'

import { Component } from 'vue-property-decorator';

import { ReactiveVue } from '@skinsoft/reactive-vue';

@Component({
    template: require('./clickable-icon-with-legend.html'),
    props: ['icon', 'legendKey']
})
export class ClickableIconWithLegend extends ReactiveVue {
    icon: string
    legendKey: string
}